import { motion } from "framer-motion";
import { IMAGES } from "../../lib/data";
import { Overline } from "./Reveal";
import { ArrowDown } from "lucide-react";

const ease = [0.16, 1, 0.3, 1];

export const Hero = () => {
  const go = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  return (
    <section id="hero" data-testid="hero-section" className="relative pt-36 pb-20 md:pt-44 md:pb-28">
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-8 items-center">
        <div className="lg:col-span-6">
          <motion.div initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8, ease }}>
            <Overline>Equine Sports Massage Therapy</Overline>
          </motion.div>
          <motion.h1
            initial={{ opacity: 0, y: 28 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.9, delay: 0.1, ease }}
            className="mt-6 font-heading text-5xl md:text-6xl lg:text-7xl font-light tracking-tight leading-[1.05] text-charcoal"
          >
            Helping your horse move
            <span className="italic text-clay"> freely</span>, feel better, perform longer.
          </motion.h1>
          <motion.p
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.9, delay: 0.25, ease }}
            className="mt-7 text-lg md:text-xl font-light leading-relaxed text-stone max-w-xl"
          >
            Stride &amp; Stone Equine offers tailored full-body sports massage at your own barn across Fredericksburg, Spotsylvania, Stafford and surrounding areas, easing tension, restoring movement, and keeping the horses you love comfortable and sound.
          </motion.p>
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.9, delay: 0.4, ease }}
            className="mt-10 flex flex-wrap items-center gap-4"
          >
            <button
              data-testid="hero-book-button"
              onClick={() => go("book")}
              className="bg-clay text-sand rounded-full px-8 py-4 font-medium transition-all duration-300 hover:bg-clay-dark hover:-translate-y-1 shadow-sm hover:shadow-md"
            >
              Request an appointment
            </button>
            <button
              data-testid="hero-learn-button"
              onClick={() => go("services")}
              className="text-charcoal border border-charcoal/20 rounded-full px-8 py-4 transition-all duration-300 hover:border-charcoal hover:bg-charcoal/5"
            >
              What I do
            </button>
          </motion.div>
        </div>

        <div className="lg:col-span-6 lg:pl-8">
          <motion.div
            initial={{ opacity: 0, scale: 1.04 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 1.1, ease }}
            className="relative"
          >
            <img
              src={IMAGES.heroMassage}
              alt="Equine sports massage therapist treating a horse"
              className="w-full h-[420px] md:h-[560px] object-cover rounded-[2rem] shadow-lg"
            />
            <div className="absolute -bottom-6 -left-4 md:-left-8 bg-sand rounded-2xl border border-charcoal/5 shadow-md px-6 py-4">
              <p className="font-heading text-3xl text-clay leading-none">100%</p>
              <p className="text-xs uppercase tracking-[0.2em] text-stone mt-1">Mobile · at your barn</p>
            </div>
          </motion.div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 md:px-12 mt-16 hidden md:flex">
        <button onClick={() => go("about")} className="flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-stone hover:text-charcoal transition-colors" data-testid="hero-scroll-cue">
          <ArrowDown size={16} strokeWidth={1.5} /> Scroll to explore
        </button>
      </div>
    </section>
  );
};
